import { Component, OnInit } from '@angular/core';

import { Location } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  color = '#0071b3';
  borderHome:string = '#263238';
  borderAbout:string = '#263238';
  borderLine:string = '#263238';
  borderContact:string = '#263238';

  constructor(
    private router: Router,
  	private location: Location
  ) {
    router.events.subscribe(val => {
  	  switch (location.path()) {
    		case '/inicio':
          this.borderHome = '2px solid ' + this.color;
          this.borderAbout = '2px solid #263238';
          this.borderLine = '2px solid #263238';
          this.borderContact = '2px solid #263238';
          break;
        case '/sobre-mi':
          this.borderHome = '2px solid #263238';
          this.borderAbout = '2px solid ' + this.color;
          this.borderLine = '2px solid #263238';
          this.borderContact = '2px solid #263238';
          break;
        case '/aprendizaje':
          this.borderHome = '2px solid #263238';
          this.borderAbout = '2px solid #263238';
          this.borderLine = '2px solid ' + this.color;
          this.borderContact = '2px solid #263238';
          break;
        case '/contacto':
          this.borderHome = '2px solid #263238';
          this.borderAbout = '2px solid #263238';
          this.borderLine = '2px solid #263238';
          this.borderContact = '2px solid ' + this.color;
          break;
  	    default:
  		    break;
      }
    });
  }

  ngOnInit(): void {
  }

  goToPage(param:string){
    this.router.navigate(['/' + param]);
  };

}
